import {
    SURVEYS_ADD_ITEM,
    SURVEYS_ADD_ITEM_SUCCESS,
    SURVEYS_ADD_ITEM_ERROR,
    SURVEYS_FETCH_ITEM,
    SURVEYS_FETCH_ITEM_SUCCESS,
    SURVEYS_FETCH_ITEM_ERROR,
    SURVEYS_DELETE_ITEM,
    SURVEYS_DELETE_ITEM_SUCCESS,
    SURVEYS_DELETE_ITEM_ERROR,
    SURVEYS_SAVE_ITEM,
    SURVEYS_SAVE_ITEM_SUCCESS,
    SURVEYS_SAVE_ITEM_ERROR,
} from './actions_def';

import moment from 'moment'
const INIT_STATE = {
    survey: null,
    errors: [],
    isLoading: false,
    isLoaded: false,
    isSaving: false,
    isSaved: false,
    hasErrors: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SURVEYS_FETCH_ITEM:
            return { ...state, isLoading: false };

        case SURVEYS_FETCH_ITEM_SUCCESS:
            return {
                ...state,
                isLoading: true,
                survey: action.payload
            };

        case SURVEYS_FETCH_ITEM_ERROR:
            return {
                ...state,
                isLoading: true,
                error: action.payload
            };

        case SURVEYS_ADD_ITEM:
            return {
                ...state,
                isSaving: true
            };

        case SURVEYS_ADD_ITEM_SUCCESS:

            return {
                ...state,
                isLoading: true,
                isSaving: false,
                errors: [],
                survey: action.payload
            };

        case SURVEYS_ADD_ITEM_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoading: true,
                isSaving: false,
                hasErrors: true,
                errors: action.payload.errors && action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        case SURVEYS_DELETE_ITEM:
            return { ...state, saving: true };

        case SURVEYS_DELETE_ITEM_SUCCESS:
            console.log("Success", state.allSurveysItems.filter(item => item && item.id !== action.payload.rfc_id))

            return {
                ...state,
                isLoading: true,
                isSaving: false,
                isSaved: true,
                errors: [],
                hasErrors: false,

            };

        case SURVEYS_DELETE_ITEM_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoading: false,
                isSaving: false,
                isSaved: true,
                errors: action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };


        case SURVEYS_SAVE_ITEM_SUCCESS:

            return {
                ...state,
                isLoading: true,
                isSaving: false,
                isSaved: true,
                errors: [],
                survey: action.payload
            };

        case SURVEYS_SAVE_ITEM_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoading: true,
                isSaving: false,
                hasErrors: true,
                errors: action.payload.errors && action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        case SURVEYS_SAVE_ITEM:
            return { ...state, isSaving: true };

        default:
            return { ...state };
    }
};
